'use client';

import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import { BaseLineIconview } from '@/app/components/icons/BaseLineIconview';
import { BaseLineList } from '@/app/components/icons/BaseLineList';
import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import { cn } from '@/app/utils';

type ViewMode = 'grid' | 'list';

interface ViewModeToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  className?: string;
}

export const ViewModeToggle: FC<ViewModeToggleProps> = ({ viewMode, onViewModeChange, className = '' }) => {
  const t = useTranslations();

  return (
    <div className={cn('flex h-7 items-center gap-2 rounded-8 bg-system-white10 px-1', className)}>
      <CustomTooltip content={t('creations.folders.listView')}>
        <button
          onClick={() => onViewModeChange('list')}
          className={`flex size-[22px] items-center justify-center rounded-4 transition-colors ${
            viewMode === 'list' ? 'bg-[#535353]' : ''
          }`}
          aria-pressed={viewMode === 'list'}
          aria-label="Switch to list view"
        >
          <BaseLineList className="text-base" />
        </button>
      </CustomTooltip>

      <CustomTooltip content={t('creations.folders.gridView')}>
        <button
          onClick={() => onViewModeChange('grid')}
          className={`flex size-[22px] items-center justify-center rounded-4 transition-colors ${
            viewMode === 'grid' ? 'bg-[#535353]' : ''
          }`}
          aria-pressed={viewMode === 'grid'}
          aria-label="Switch to grid view"
        >
          <BaseLineIconview className="text-sm" />
        </button>
      </CustomTooltip>
    </div>
  );
};
